import Icon from '@mdi/react';
import { Button, Stack, SxProps } from '@mui/material';
import React from 'react';
import { headingFontBold, vars } from '../../../Theme';

/** Styles for the action button. */
const buttonSx: SxProps = {
    flexDirection: 'column',
    textTransform: 'none',
    color: vars.font,
    ...headingFontBold,
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    p: 0.5,
    minWidth: 5,
};

/**
 * Button Component that allows the user to perform an action on the selected documents.
 */
export default ({ icon, text, onClick, disabled, sx, color }: IActionButtonProps) => (
    <Button onClick={onClick} sx={{ ...buttonSx, ...sx }} disabled={disabled}>
        <Icon path={icon} color={color ?? vars.font} size={1} />
        <Stack>{text}</Stack>
    </Button>
);

/**
 * Interface that describes the props for an ActionButton component.
 */
interface IActionButtonProps {
    /** Button icon. */
    icon: string;

    /** Button text. */
    text: string;

    /** Click handler for the button. */
    onClick: React.MouseEventHandler<HTMLButtonElement>;

    /** Color for icon. */
    color?: string;

    /** (OPTIONAL) Button disabled state. */
    disabled?: boolean;

    /** Styling for ActionButton */
    sx?: SxProps;
}
